// extracted by mini-css-extract-plugin
export default {"AssumedIdentityBanner":"AssumedIdentityBanner_AssumedIdentityBanner__52wsN"};